import { combineReducers } from "@reduxjs/toolkit";
import { bootstrapReducer } from "./bootstrap/index";
import { fileReducer } from "./file/fileSlice";

import { loadingReducer } from "./loading";
import { projectReducer } from "@/features/projects/stores/project/projectSlice";
import { sidebarReducer } from "./sidebar";
import { uploadReducer } from "@/features/upload/stores/upload/uploadSlice";
import appReducer from "./app.slice";
import { uploadFileReducer } from "@/features/upload/stores/uploadFiles/uploadFileSlice";
import fileStatusReducer from "@/features/file-management/stores/convertFile/convertFile.slice";
import selectedFilesReducer from "./selectedFiles/selectedFiles.slice";
import drawingsReducer from "@/features/drawings/stores/drawingsSlice";
import teamDrivesReducer from "@/features/drive/stores/teamDrives/teamDrivesSlice";
import { extractionReducer } from "@/features/file-management/pages/FilePage/redux/extraction.slice";
import modalReducer from "@/store/modal.slice";
import { deleteFileReducer } from "./deleteFile";
import { archiveFileReducer } from "@/features/file-management/stores/archiveFile";
import shareModalReducer from "./shareModal.slice";
import { searchReducer } from "./search";
import permissionReducer from "./permission/permissionSlice";
import organizationUsersReducer from "@/features/projects/stores/organizationUsers/organizationUsersSlice";
import { navigationReducer } from "./navigation/navigationSlice";
import { organizationsReducer } from "@/features/projects/stores/organizations";
import { preferencesReducer } from "@/features/settings/stores/preferences";
import contextMenuReducer from "./contextMenu.slice";
import authReducer from "@/features/auth/stores/authSlice";
import labelReducer from "@/features/file-management/stores/labelSlice";
import moveReducer from "@/features/file-management/stores/move/moveSlice";
import folderUploadReducer from "@/features/upload/stores/folderUpload/folderUploadSlice";
import rightbarReducer from "./rightbar/rightbarSlice";
import { driveReducer } from "@/features/drive/stores/drive/driveSlice";
import { workflowReducer } from "@/features/workflow/stores/workflowSlice";
import trashPageReducer from "@/features/trash/stores/dataLoaderSlice";
import { workflowAnalyticReducer } from "@/features/workflow/stores/workflowAnalyticSlice";
import groupUserReducer from "@/features/settings/stores/groupUserSlice";
import storageReducer from "@/features/settings/components/StorageManagement/redux/storageSlice";


const mainReducer = combineReducers({
  loading: loadingReducer,
  file: fileReducer,
  bootstrap: bootstrapReducer,
  upload: uploadReducer,
  sidebar: sidebarReducer,
  project: projectReducer,
  drive: driveReducer,
  app: appReducer,
  fileStatus: fileStatusReducer,
  uploadFile: uploadFileReducer,
  selectedFiles: selectedFilesReducer,
  drawings: drawingsReducer,
  teamDrives: teamDrivesReducer,
  extraction: extractionReducer,
  modal: modalReducer,
  deleteFile: deleteFileReducer,
  archiveFile: archiveFileReducer,
  shareModal: shareModalReducer,
  search: searchReducer,
  permission: permissionReducer,
  organizationUsers: organizationUsersReducer,
  navigation: navigationReducer,
  organizations: organizationsReducer,
  preferences: preferencesReducer,
  contextMenu: contextMenuReducer,
  auth: authReducer,
  label: labelReducer,
  move: moveReducer,
  folderUpload: folderUploadReducer,
  rightbar: rightbarReducer,
  workflow: workflowReducer,
  trashPage: trashPageReducer,
  workflowAnalytic: workflowAnalyticReducer,
  groupUser: groupUserReducer,
  storage: storageReducer,
});

const rootReducers = (state: any, action: never) => {
  return mainReducer(state, action);
};

export type RootState = ReturnType<typeof mainReducer>;
export default rootReducers;
